import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { Modal } from "./Modal"

interface IProps {
  data: any
  handler: any
  text: string
  actionText: string
  actionHandler: any
  /** Styling for the confirm button. Defaults to the usual primary; pass `btn-error` when the action destroys something. */
  actionClassName?: string
}

export const ModalConfirmAction = (props: IProps) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const { data, handler, text, actionText, actionHandler, actionClassName = "btn-primary" } = props

  // const { t } = useTranslation("translation", { useSuspense: false })

  const onSubmit = async (): Promise<void> => {
    await actionHandler(data)
    handler()
  }

  return (
    <Modal open={Boolean(data)} handler={handler}>
      <div className="relative flex flex-col justify-between modal-box">
        {text && <p>{text}</p>}
        <div className="modal-action">
          <button className="btn btn-secondary" onClick={handler}>
            {t("common.cancel")}
          </button>
          <button className={clsx("btn", actionClassName)} onClick={onSubmit}>
            {actionText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
